import "./ClassDetails.scss";
import { useState, useEffect,useMemo } from "react";
import CustDatePicker from "../../../components/CustomDate/CustomDatePicker";
import Collaboration from "./Collaboration/Collaboration";
import {
  mergeSelectedIntoOptions,
  mergeSelectedWithList,
  useOrgOptions,
  useTrainerOptions,
} from "../../../components/Hooks/classDetailMultiDropdownHook";
import {
  addClassDetail,
  getCountry,
  getState,
  getStudentList,
  updateTrainingSession,
} from "../../../services/training-session.service";
import { useNavigate, useLocation } from "react-router-dom";
import { useSessionEditContext } from "../../../components/Hooks/sessionEditContext";
import Headings from "../../../components/Headings/Headings";
import AuiButton from "../../../components/Buttons/Buttons";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../store/alertSlice";
import DropDown from "../../../components/DropDown/DropDown";
import LocationInfo from "../../../components/Filters/LocationInfo";
import SearchableMultiSelectDropdown from "../../../components/DynamicDropdowns/SearchableMultiSelectDropdown";
import { useDebouncedSearch } from "../../../utils/constants/app-constants";
import { DropdownOption } from "../../../components/Filters/OrganizationFilterSection";

interface CourseOption {
  label: string;
  value: string;
}
interface ClassDetailsProps {
  trainingSession: any;
}
interface DateTimeParams {
  date: Date | null;
  time: string;
}

interface SessionParams {
  sessionId: any;
  trainingSession: any;
  becDuration: any;
  becDateTime: DateTimeParams;
  totDuration: any;
  totDateTime: DateTimeParams;
}
const ClassDetails = ({trainingSession}: ClassDetailsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = parseInt(queryParams.get("id") ?? "-1");
  const [courseTypeValue, setCourseTypeValue] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [classTypeValue, setClassTypeValue] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const courseDropdownOptions = [
    { label: "BEC", value: "BEC" },
    { label: "BEC TOT", value: "BEC TOT" },
    { label: "BEC + BEC TOT", value: "BEC+BEC TOT" },
  ];
  const classDropdownOptions = [
    { label: "Classic", value: "Classic" },
    { label: "Hybrid", value: "Hybrid" },
  ];
  const { options: masterTrainers, isUploadloading: masterTrainersLoading, fetchOptions: fetchMasterOptions } = useTrainerOptions("MASTER_TRAINER");
  const { options: registeredTrainers, isUploadloading: registeredTrainersLoading, fetchOptions: fetchRegisteredOptions } = useTrainerOptions("REGISTERED_FACILITATOR");
  const { options: provisionalTrainers, isUploadloading: provisionalTrainersLoading, fetchOptions: fetchProvisionalOptions } = useTrainerOptions("PROVISIONAL_FACILITATOR");
  const { options: organisationList, isUploadloading: orgListLoading, fetchOrganisation: fetchOrgOptions } = useOrgOptions(1);
  const [selectedMasterTrainers, setSelectedMasterTrainers] = useState<any[]>(
    []
  );
  const [selectedRegisteredTrainers, setSelectedRegisteredTrainers] = useState<
    any[]
  >([]);
  const [selectedProvisionalTrainers, setSelectedProvisionalTrainers] =
    useState<any[]>([]);
  const [numberOfStudents, setNumberOfStudents] = useState<number | null>(null);
  const [inputValue, setInputValue] = useState(false);
  const [collabOrganisation, setCollabOrganisation] = useState<any[]>([]);
  const [becDate, setBecDate] = useState<Date | null>(null);
  const [becDuration, setBecDuration] = useState<number | string>("");
  const [totDate, setTotDate] = useState<Date | null>(null);
  const [totDuration, setTotDuration] = useState<number | string>("");
  const [maxStudVal, setMaxStudVal] = useState(0);
  const { setSessionInfo } = useSessionEditContext();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [totalTrainerSelected, setTotalTrainerSelected] = useState(0);
  const [studentCount, setStudentCount] = useState<any>();
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [hasStudents, setHasStudents] = useState(false);
  const [isEditPageLoading, setIsEditPageLoading] = useState(sessionId !== -1);
  const [becDurationError, setBecDurationError] = useState<string>("");
  const [totDurationError, setTotDurationError] = useState<string>("");
  const [countries, setCountries] = useState<DropdownOption[]>([]);
  const [states, setStates] = useState<DropdownOption[]>([]);
  const [regions, setRegions] = useState<DropdownOption[]>([]);
  const [city, setCity] = useState<string>("");
  const [alertType, setAlertType] = useState<"primary" | "error">("primary");
  const [selectedCountry, setSelectedCountry] = useState<DropdownOption | null>(
    null
  );
  const [selectedState, setSelectedState] = useState<DropdownOption | null>(
    null
  );
  const [selectedRegion, setSelectedRegion] = useState<DropdownOption | null>(
    null
  );
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [hasPrefilledLocation, setHasPrefilledLocation] = useState(false);

  const mergedCountryList = useMemo(
    () => mergeSelectedWithList(countries, selectedCountry, "code"),
    [countries, selectedCountry]
  );

  const mergedRegionList = useMemo(
    () => mergeSelectedWithList(regions, selectedRegion, "code"),
    [regions, selectedRegion]
  );

  const mergedStateList = useMemo(
    () => mergeSelectedWithList(states, selectedState, "code"),
    [states, selectedState]
  );

  const fetchCountries = async (search: string) => {
    setIsDataLoading(true);
    const fetchedCountries = await getCountry(search);
    setCountries(fetchedCountries);
    setRegions(fetchedCountries);
    setIsDataLoading(false);
  };



  const fetchStates = async (search: string) => {
    if (!selectedCountry?.code) return;

    setIsDataLoading(true);
    const fetchedStates = await getState(selectedCountry?.code, search);
    setStates(fetchedStates);
    setIsDataLoading(false);
  };

  useEffect(() => {
    fetchCountries("");
  }, []);

  useEffect(() => {
    setRegions([]);
    setSelectedRegion(null);
    setStates([]);
    setSelectedState(null);

    if (selectedCountry?.id) {
      debouncedSearchStates("");
    }
  }, [selectedCountry]);



useEffect(() => {
  if (studentCount && studentCount !== "") {
    validateStudentCount(studentCount.toString());
  }
}, [maxStudVal, totalTrainerSelected,classTypeValue]);

  const debouncedSearchCountries = useDebouncedSearch(fetchCountries);
  const debouncedSearchStates = useDebouncedSearch(fetchStates);

const handleStudentCount = (e: React.ChangeEvent<HTMLInputElement>) => {
  const inputStudValue = e.target.value;
  setStudentCount(inputStudValue);
  const studentCount = parseInt(inputStudValue);
  setNumberOfStudents(studentCount);
  validateStudentCount(inputStudValue);
};

const validateStudentCount = (inputStudValue: string) => {
  const pattern = /^[1-9]\d*$/;
  const studenttNum = parseInt(inputStudValue);
  const classType = classTypeValue?.value?.trim();
  const trainers = totalTrainerSelected;
  let maxStudVal = calculateMaxStudentVal(classType, totalTrainerSelected);

  if (!inputStudValue && inputStudValue === "") {
    setErrorMessage("This field is required");
    return false;
  }
  if (!RegExp(pattern).exec(inputStudValue)) {
    setErrorMessage("Please enter a valid number.");
    return false;
  }

  if (!classType && trainers === 0) {
    setErrorMessage("Please choose a class type.");
    return false;
  }

  if (!classType) {
    setErrorMessage("Please choose class type.");
    return false;
  }


  if (studenttNum > maxStudVal && trainers>0) {
    setErrorMessage(
      `Maximum ${maxStudVal} Students assigned for ${totalTrainerSelected} Facilitator`
    );
    return false;
  }
  setErrorMessage(null);
  return true;
};

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Allow only numeric keys and control keys (e.g., backspace, arrow keys)
    if (
      !(
        (e.key >= "0" && e.key <= "9") ||
        [
          "Backspace",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Tab",
        ].includes(e.key)
      )
    ) {
      e.preventDefault();
    }
  };
  const handleBecDuration = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "") {
      setBecDurationError("This field is required");
      setBecDuration("");
    } else if (Number(value) <= 0) {
      setBecDurationError("Duration in days cannot be 0");
      setBecDuration("");
    } else {
      setBecDurationError("");
      setBecDuration(Number(value));
    }
  };
  const handleTotDuration = (e: React.ChangeEvent<HTMLInputElement>) => {
    const Totduration = parseFloat(e.target.value);
    if(e.target.value === "") {
      setTotDurationError("This field is required")
    } else if(isNaN(Totduration) || Totduration <=0) {
      setTotDurationError("Duration in days cannot be 0");
    } else {
      setTotDurationError("");
    }
    setTotDuration(isNaN(Totduration) ? "" : Totduration);
  };


const calculateEndDate = (becStartDate: any, becCourseDuration: any): Date => {
  const startDate = new Date(becStartDate);
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + becCourseDuration);
  return endDate;
};

const calculateStartDate = (totStartDate: any): Date => {
  return new Date(totStartDate);
};

const endDate = calculateEndDate(becDate, becDuration);
const courseStartDate = calculateStartDate(totDate);

  function getCommonInstances(inputValue: boolean, numberOfStudents: number | null, trainingSession: any) {
    return {
      sponsoringOrgId: 100,
      approvingOrgId: 200,
      isCollaborationEnabled: inputValue,
      totalStudent: numberOfStudents,
      status: trainingSession?.status ?? "DRAFT",
      isRoasterFinalised: false,
      isActive: true,
    };
  }
  
function formatLocalDate(dateInput: Date): string {
  // Use local date parts to avoid UTC shift
  const year = dateInput.getFullYear();
  const month = `${dateInput.getMonth() + 1}`.padStart(2, "0");
  const day = `${dateInput.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}
  
  function getDateTime(date: Date | null, time: string) {
    if (date) {
      const localDate = formatLocalDate(date);
      return `${localDate}T${time}:00Z`;
    }
    return null;
  }
  
  function getTrainerInstance(
    courseTypeValue: any,
    commonInstances: any,
    sessionParams: SessionParams
  ) {
    const {
      sessionId,
      trainingSession,
      becDuration,
      becDateTime,
      totDuration,
      totDateTime,
    } = sessionParams;

    switch (courseTypeValue.value) {
      case "BEC+BEC TOT":
        return [
          {
            ...commonInstances,
            id: sessionId ? trainingSession?.trainingInstance?.[0]?.id : "",
            duration: becDuration,
            startDate: getDateTime(becDateTime.date, becDateTime.time),
            endDate: getDateTime(becDateTime.date, becDateTime.time),
            trainingTypeCode: "BEC",
          },
          {
            ...commonInstances,
            id: sessionId ? trainingSession?.trainingInstance?.[1]?.id : "",
            duration: totDuration,
            startDate: getDateTime(totDateTime.date, totDateTime.time),
            endDate: getDateTime(totDateTime.date, totDateTime.time),
            trainingTypeCode: "BEC TOT",
          },
        ];
      case "BEC":
        return [
          {
            ...commonInstances,
            id: sessionId ? trainingSession?.trainingInstance?.[0]?.id : "",
            duration: becDuration,
            startDate: getDateTime(becDateTime.date, becDateTime.time),
            endDate: getDateTime(becDateTime.date, becDateTime.time),
            trainingTypeCode: "BEC",
          },
        ];
      case "BEC TOT":
        return [
          {
            ...commonInstances,
            id: sessionId ? trainingSession?.trainingInstance?.[0]?.id : "",
            duration: totDuration,
            startDate: getDateTime(totDateTime.date, totDateTime.time),
            endDate: getDateTime(totDateTime.date, totDateTime.time),
            trainingTypeCode: "BEC TOT",
          },
        ];
      default:
        console.error("Invalid course type");
        return [];
    }
  }
  
  async function handleSavesubmit(): Promise<void> {
    if (isFormDisabled || isBtnLoading) {
      return;
    }

    const totalTrainers =
      selectedMasterTrainers.length +
      selectedRegisteredTrainers.length +
      selectedProvisionalTrainers.length;

    if (totalTrainers <= 0) {
      setAlertType("error");
      return;
    }

    if (courseTypeValue.value === "BEC+BEC TOT" && endDate >= courseStartDate) {
      dispatch(
        showAlert({
          message:
            "The start date and time of the TOT class must be after the end date and time of the BEC class",
          type: "error",
        })
      );
      return;
    }

    const commonInstances = getCommonInstances(
      inputValue,
      numberOfStudents,
      trainingSession
    );
    const sessionParams: SessionParams = {
      sessionId,
      trainingSession,
      becDuration,
      becDateTime: { date: becDate, time: "00:00" },
      totDuration,
      totDateTime: { date: totDate, time:  "00:00"  },
    };
    const trainerInstance = getTrainerInstance(
      courseTypeValue,
      commonInstances,
      sessionParams
    );

    const organisationPayload = JSON.stringify({
      trainingTypeCode: courseTypeValue.value,
      isHybrid: classTypeValue.value === "Hybrid",
      isActive: true,
      isCollaborationEnabled: inputValue,
      collaboratingOrganisation: inputValue
        ? collabOrganisation.map((org) => ({
            organisationID: parseInt(org.value),
            isActive: true,
          }))
        : [],
      trainingInstance: trainerInstance,
      trainingSessionTrainer: [
        ...selectedMasterTrainers.map((type) => ({
          trainerId: parseInt(type.value),
          trainerType: "MASTER_TRAINER",
          isActive: true,
        })),
        ...selectedRegisteredTrainers.map((type) => ({
          trainerId: parseInt(type.value),
          trainerType: "REGISTERED_FACILITATOR",
          isActive: true,
        })),
        ...selectedProvisionalTrainers.map((type) => ({
          trainerId: parseInt(type.value),
          trainerType: "PROVISIONAL_FACILITATOR",
          isActive: true,
        })),
      ],
      sessionGeography: {
        countryId: selectedCountry?.id,
        stateId: selectedState?.id,
        regionId: selectedCountry?.regionId,
        city: city?.trim(),
      },
    });
    try {
      setIsBtnLoading(true);
      if (sessionId === -1) {
        const sessionInfo = await addClassDetail(organisationPayload);
        setSessionInfo(sessionInfo);
        const id = sessionInfo.data.trainingSession.id;
        dispatch(
          showAlert({
            message: "Course created successfully!",
            type: "success",
          })
        );
        navigate(`/create-course/upload?id=${id}`);
      } else {
        const updatedSession = await updateTrainingSession(
          sessionId,
          organisationPayload
        );
        if (updatedSession) {
          dispatch(
            showAlert({
              message: "Course updated successfully!",
              type: "success",
            })
          );
          navigate(`/create-course/upload?id=${sessionId}`);
        } else {
          console.error("Failed to update session");
        }
      }
    } catch (error) {
      console.error("Error saving session:", error);
    } finally {
      setIsBtnLoading(false);
    }
  }


  // Function to check if the form is valid
  const isFormValid = () => {
    const totalTrainers =
      selectedMasterTrainers.length +
      selectedRegisteredTrainers.length +
      selectedProvisionalTrainers.length;
      let classType = classTypeValue.value;

    let maxStudVal = calculateMaxStudentVal(classType, totalTrainers);

    const courseType = courseTypeValue.value;
    const locationFieldsValid =
    !!selectedCountry?.regionId &&
    !!selectedState?.id &&
    !!selectedCountry?.id &&
    !!city.trim();

    if (courseType === "BEC") {
      return (
        classTypeValue.value !== "" &&
        !!becDuration &&
        numberOfStudents !== null &&
        numberOfStudents !== 0 &&
        (totalTrainers === 0 || numberOfStudents <= maxStudVal) &&
        becDate !== null &&
        locationFieldsValid
      );
    }

    if (courseType === "BEC TOT") {
      return (
        classTypeValue.value !== "" &&
        !!totDuration &&
        numberOfStudents !== null &&
        numberOfStudents !== 0 &&
        (totalTrainers === 0 || numberOfStudents <= maxStudVal) &&
        totDate !== null &&
        locationFieldsValid
      );
    }

    if (courseType === "BEC+BEC TOT") {
      return (
        classTypeValue.value !== "" &&
        !!becDuration &&
        !!totDuration &&
        numberOfStudents !== null &&
        numberOfStudents !== 0 &&
        (totalTrainers === 0 || numberOfStudents <= maxStudVal) &&
        becDate !== null &&
        totDate !== null &&
        locationFieldsValid
      );
    }
    return false;
  };

  useEffect(() => {
    if (isFormValid()) {
      setAlertType("primary");
    }
    setIsFormDisabled(!isFormValid())
  }, [
    courseTypeValue,
    classTypeValue,
    selectedMasterTrainers,
    selectedRegisteredTrainers,
    selectedProvisionalTrainers,
    numberOfStudents,
    inputValue,
    collabOrganisation,
    becDate,
    becDuration,
    totDate,
    totDuration,
    selectedRegion,
    selectedState,
    selectedCountry,
    city
  ]);

  useEffect(() => {
    const totalTrainers =
      selectedMasterTrainers.length +
      selectedRegisteredTrainers.length +
      selectedProvisionalTrainers.length;
    setTotalTrainerSelected(totalTrainers);
    let classType = classTypeValue.value;

    let calculatedMaxStudVal = calculateMaxStudentVal(classType, totalTrainers);
    setMaxStudVal(calculatedMaxStudVal > 0 ? calculatedMaxStudVal : 0);

    if (calculatedMaxStudVal > 0) {
      setErrorMessage(null);
    }
  }, [
    selectedMasterTrainers,
    selectedRegisteredTrainers,
    selectedProvisionalTrainers,
  ]);

  useEffect(() => {
    if (sessionId === -1 || !trainingSession) return;
    const matchedCourseOption = courseDropdownOptions.find(
      (option) => option.value === trainingSession?.trainingTypeCode
    );

    if (matchedCourseOption) {
      setCourseTypeValue(matchedCourseOption);
    }
    setClassTypeValue(
      trainingSession?.isHybrid
        ? { label: "Hybrid", value: "Hybrid" }
        : { label: "Classic", value: "Classic" }
    );

    if (trainingSession?.collaboratingOrganisation.length) {
      setInputValue(true);
    }

    const [first, second] = trainingSession?.trainingInstance || [];

    if (first) {
      setStudentCount(first.totalStudent);
      setNumberOfStudents(first.totalStudent);
      let [datePart] = first?.startDate?.split("T") ?? ["", ""];
      const utcDate = new Date(`${datePart}T00:00:00Z`); //format to UTC
      if (first?.trainingTypeCode !== "BEC TOT") {
        setBecDate(utcDate);
        setBecDuration(first?.duration);
      } else {
        setTotDate(utcDate);
        setTotDuration(first?.duration);
      }
    }
    if (second) {
      let [datePart] = second?.startDate?.split("T") ?? ["", ""];
      const utcDate = new Date(`${datePart}T00:00:00Z`); //format to UTC
      setTotDate(utcDate);
      setTotDuration(second?.duration);
    }
  }, [sessionId, trainingSession]);

  useEffect(() => {
  if (
    sessionId === -1 || 
    hasPrefilledLocation ||
    !trainingSession ||
    !countries.length ||
    selectedCountry
  )
    return;

  if (trainingSession.sessionGeography?.country) {
    setSelectedCountry(trainingSession.sessionGeography.country);
  }
}, [trainingSession, countries, selectedCountry, hasPrefilledLocation]);

useEffect(() => {
    if (
      sessionId === -1 || 
      hasPrefilledLocation ||
      !trainingSession ||
      !regions.length ||
      selectedRegion
    )
      return;

    if (trainingSession.sessionGeography?.region) {
      setSelectedRegion(trainingSession.sessionGeography.country);
    }
  }, [trainingSession, regions, selectedRegion, hasPrefilledLocation]);

  useEffect(() => {
    if (
      sessionId === -1 || 
      hasPrefilledLocation ||
      !trainingSession ||
      !states.length ||
      selectedState
    )
      return;

    if (trainingSession.sessionGeography?.state) {
      setSelectedState(trainingSession.sessionGeography.state);
      setHasPrefilledLocation(true);
    }
  }, [trainingSession, states, selectedState, hasPrefilledLocation]);

  useEffect(() => {
    if (sessionId === -1 || !trainingSession) return;
    const matchedCity = trainingSession.sessionGeography?.city || "";
    setCity(matchedCity);
  }, [trainingSession]);

  useEffect(() => {
    if (sessionId === -1) {
      return;
    }
    const fetchStudents = async () => {
      const response: any = await getStudentList(sessionId, 1, 10);
      setHasStudents(!!response?.students?.length);
    };
    fetchStudents();
  }, [sessionId]);

  useEffect(() => {
    if (sessionId === -1 || !trainingSession) return;

    const selectedMaster: any[] = [];
    const selectedRegistered: any[] = [];
    const selectedProvisional: any[] = [];

    trainingSession.trainingSessionTrainer?.forEach((trainer: any) => {
      const formattedTrainer = {
        label: `${trainer.firstName} ${trainer.lastName}`,
        value: trainer.trainerId.toString(),
      };

      switch (trainer.trainerType) {
        case "MASTER_TRAINER":
          selectedMaster.push(formattedTrainer);
          break;
        case "REGISTERED_FACILITATOR":
          selectedRegistered.push(formattedTrainer);
          break;
        case "PROVISIONAL_FACILITATOR":
          selectedProvisional.push(formattedTrainer);
          break;
      }
    });

    setSelectedMasterTrainers(selectedMaster);
    setSelectedRegisteredTrainers(selectedRegistered);
    setSelectedProvisionalTrainers(selectedProvisional);
    setIsEditPageLoading(false);
  }, [trainingSession]);

  useEffect(() => {
    if (!trainingSession?.collaboratingOrganisation) return;

    const selectedOrgs = trainingSession.collaboratingOrganisation.map(
      (org: any) => ({
        label: org.organisationName,
        value: org.organisationId.toString(),
      })
    );

    setCollabOrganisation(selectedOrgs);
  }, [trainingSession]);

  useEffect(() => {
    if (sessionId === -1) {
      setCourseTypeValue({ label: "", value: "" });
      setClassTypeValue({ label: "", value: "" });
      setSelectedMasterTrainers([]);
      setSelectedRegisteredTrainers([]);
      setSelectedProvisionalTrainers([]);
      setNumberOfStudents(null);
      setInputValue(false);
      setCollabOrganisation([]);
      setBecDate(null);
      setBecDuration("");
      setTotDate(null);
      setTotDuration("");
      setCity("");
      setSelectedCountry(null);
      setSelectedState(null);
      setSelectedRegion(null);
      setErrorMessage(null);
      setStudentCount(null);
      setBecDurationError("");
      setTotDurationError("");
    }
  }, []);

  const calculateMaxStudentVal = (
    classType: string,
    totalTrainers: number
  ): number => {
    if (classType === "Classic") {
      return totalTrainers * 6;
    } else if (classType === "Hybrid") {
      return totalTrainers * 4;
    }
    return 0;
  };

  return (
    <div className="class-detail-wrapper">
      <Headings
        className={`blue`}
        defaultClass="h7"
        size="h2"
        id="classInfodetails"
      >
        Class Details
      </Headings>
      {isEditPageLoading && (
        <div className="aui-loader loaderHeight">
          <aui-loader type="content"></aui-loader>
        </div>
      )}
      {!isEditPageLoading && (
        <div>
          <div className="course-request">
            <div className="row">
              <div className="col-12 col-md-4 mt-3 mb-lg-0">
              <DropDown
                  dropdownLabel="Course Type"
                  mainId="coursetype"
                  dropId="courseType"
                  placeHolder="Select Course Type"
                  data={courseDropdownOptions.map((v) => v.label)}
                  listInBtn
                  required={true}
                  value={courseTypeValue.label}
                  errorText="Please select a Course Type"
                  onChange={(value: string) => {
                    const selectedOption = courseDropdownOptions.find(
                      (option) => option.label === value
                    );
                    if (selectedOption) {
                      setCourseTypeValue(selectedOption);
                    } else {
                      setCourseTypeValue({
                        label: "",
                        value: "",
                      });
                    }
                  }}
                ></DropDown>
              </div>
              <div className="col-12 col-md-4 mt-3 mb-lg-0">
              <DropDown
                  dropdownLabel="Class Type"
                  mainId="classtype"
                  dropId="classtype"
                  placeHolder="Select Class Type"
                  data={classDropdownOptions.map((v) => v.label)}
                  listInBtn
                  required={true}
                  value={classTypeValue.label}
                  errorText="Please select a Class Type"
                  onChange={(value: string) => {
                    const selectedOption = classDropdownOptions.find(
                      (option) => option.label === value
                    );
                    if (selectedOption) {
                      setClassTypeValue(selectedOption);
                    } else {
                      setClassTypeValue({
                        label: "",
                        value: "",
                      });
                    }
                  }}
                ></DropDown>
              </div>
              <div className="col-12 col-md-4 mt-3 mb-lg-0">
              <SearchableMultiSelectDropdown
                  dropId="masterTrainer"
                  dropdownLabel="Master Trainer"
                  placeHolder="Select Master Trainer"
                  data={mergeSelectedIntoOptions(masterTrainers, selectedMasterTrainers)}
                  selectedOptions={selectedMasterTrainers}
                  isLoading={masterTrainersLoading}
                  onSearch={(term) => fetchMasterOptions(term)}
                  onChange={(selected) => {
                    setSelectedMasterTrainers(selected);
                  }}
                />
              </div>
            </div>
            <div className="row mt-2 mt-lg-4 mb-2">
              <div className="col-12 col-md-4">
              <SearchableMultiSelectDropdown
                  dropId="RegisteredFacilitator/s"
                  dropdownLabel="Registered Facilitator/s"
                  placeHolder="Select Registered Facilitator/s"
                  data={mergeSelectedIntoOptions(registeredTrainers, selectedRegisteredTrainers)}
                  selectedOptions={selectedRegisteredTrainers}
                  isLoading={registeredTrainersLoading}
                  onSearch={(term) => fetchRegisteredOptions(term)}
                  onChange={(selected) => {
                    setSelectedRegisteredTrainers(selected);
                  }}
                />
              </div>
              <div className="col-12 col-md-4">
              <SearchableMultiSelectDropdown
                  dropId="ProvisionalFacilitator/s"
                  dropdownLabel="Provisional Facilitator/s"
                  placeHolder="Select Provisional Facilitator/s"
                  data={mergeSelectedIntoOptions(provisionalTrainers, selectedProvisionalTrainers)}
                  selectedOptions={selectedProvisionalTrainers}
                  isLoading={provisionalTrainersLoading}
                  onSearch={(term) => fetchProvisionalOptions(term)}
                  onChange={(selected) => {
                    setSelectedProvisionalTrainers(selected);
                  }}
                />
              </div>
              <div className="col-12 col-md-4 itemcountsInput form-group">
                <label id="quantity-label" className="col-form-label" htmlFor="quantity">
                  Number of Students {''}
                  <span className="requiredLabel" aria-hidden="true">*</span>
                  <span className="visually-hidden">required</span>
                </label>
                <input
                  className={hasStudents ? "disabled" : ""}
                  type="number"
                  id="quantity"
                  name="quantity"
                  min="0"
                  max={maxStudVal}
                  placeholder="Enter Number of Students"
                  aria-labelledby="quantity-label"
                  onChange={handleStudentCount}
                  onKeyDown={handleKeyDown}
                  value={studentCount}
                  disabled={hasStudents}
                ></input>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
              </div>
            </div>
            <div className="mb-3">
              <aui-alert
                type={alertType}
                className="w-100 shadow-sm border-0 rounded-3 p-3"
              >
                <p className="mb-0" id="alert">
                  At least one trainer (Master trainer / Registered facilitator
                  / Provisional facilitator) is required.
                </p>
              </aui-alert>
            </div>
          </div>
          <div className="location-details border-bottom py-3">
            <Headings
              className={`blue`}
              defaultClass="h7"
              size="h2"
              id="locationDetail"
            >
              Location Details
            </Headings>
            <LocationInfo
              setCountry={setSelectedCountry}
              setState={setSelectedState}
              setRegion={setSelectedRegion}
              countries={mergedCountryList}
              states={mergedStateList}
              regions={mergedRegionList}
              selectedCountry={selectedCountry}
              selectedState={selectedState}
              isDataLoading={isDataLoading}
              setCity={setCity}
              selectedCity={city}
              debouncedSearchCountries={debouncedSearchCountries}
              debouncedSearchStates={debouncedSearchStates}
              />
          </div>
          <div className="collaboration mt-xl-4 pb-2 border-bottom">
            <Collaboration
              inputValue={inputValue}
              setInputValue={setInputValue}
              collabOrganisation={collabOrganisation}
              organisationList={mergeSelectedIntoOptions(organisationList, collabOrganisation)}
              setCollabOrganisation={setCollabOrganisation}
              orgListLoading={orgListLoading}
              fetchOrgOptions={fetchOrgOptions}
            />
          </div>

          {(courseTypeValue.value === "" ||
            courseTypeValue.value === "BEC" ||
            courseTypeValue.value === "BEC+BEC TOT") && (
            <div className="bec-class-information border-bottom py-3">
              <Headings
                className={`blue`}
                defaultClass="h7"
                size="h2"
                id="classBECclass"
              >
                BEC Class information
              </Headings>
              <div className="row">
                <div className="col-12 col-md-4">
                  <CustDatePicker date={becDate} setDate={setBecDate} />
                </div>
                <div className="col-12 col-md-4 itemcountsInput form-group">
                  <label className="col-form-label" htmlFor="becDuration">
                    Duration in Days{' '}
                    <span className="requiredLabel" aria-hidden="true">
                      *
                    </span>
                    <span className="visually-hidden">required</span>
                  </label>
                  <input
                    type="number"
                    id="becDuration"
                    name="becDuration"
                    min="1"
                    max="20"
                    step="1"
                    placeholder="Enter Duration in Days"
                    aria-label="Duration in Days"
                    value={becDuration}
                    onChange={handleBecDuration}
                    onKeyDown={handleKeyDown}   
                  ></input>
                  {becDurationError && <div className="error-message">{becDurationError}</div>}
                </div>
              </div>
            </div>
          )}

          {(courseTypeValue.value === "BEC TOT" ||
            courseTypeValue.value === "BEC+BEC TOT") && (
            <div className="tot-class-information border-bottom pb-3">
              <Headings
                size="h2"
                defaultClass="h7 blue"
                className={`mt-2 bordered pb-3 mb-0`}
              >
                TOT Class information
              </Headings>
              <div className="row">
                <div className="col-12 col-md-4">
                  <CustDatePicker date={totDate} setDate={setTotDate} />
                </div>
                <div className="col-12 col-md-4 itemcountsInput form-group">
                  <label className="col-form-label" htmlFor="totDuration">
                    Duration in Days{' '}
                    <span className="requiredLabel" aria-hidden="true">
                      *
                    </span>
                    <span className="visually-hidden">required</span>
                  </label>
                  <input
                    type="number"
                    id="totDuration"
                    name="totDuration"
                    min="0"
                    max="100"
                    placeholder="Enter Duration in Days"
                    aria-label="Duration in Days"
                    value={totDuration}
                    onChange={handleTotDuration}
                  ></input>
                  {totDurationError && <div className="error-message">{totDurationError}</div>}
                </div>
              </div>
            </div>
          )}
          <div className="d-flex justify-content-end mt-lg-5 mb-lg-3">
            <AuiButton
              data-testid="save-next-button"
              variant="primary"
              buttontitle="Save & Next"
              modalid="exampleModal"
              buttonClick={handleSavesubmit}
              disabled={isFormDisabled}
              buttonid={""}
              size="medium"
              loading={isBtnLoading}
            ></AuiButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassDetails;